import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import { DateTimeHelper } from '../../utils/DateTimeHelper.util';
import { isNullOrUndefined } from 'util';

@Component
class DatetimePickerRange extends Vue {

  @Prop({
    default: () => {
      return {
        startDate: moment(),
        endDate: moment().add('m', 15)
      }
    }, type: [Object]
  })
  value: { startDate: string | Date | Moment, endDate: string | Date | Moment }

  @Prop({ default: 15, type: [Number] })
  step: number;
  @Prop({
    default: () => ({
      beginningAt: 7,
      end: 22
    }), type: [Object]
  })
  businessHours: { beginningAt: number, end: number };
  @Prop({ default: true, type: [Boolean] })
  is24h: boolean;
  @Prop({ default: 'La date de début doit être supérieure à la date de fin', type: [String] })
  errorMessage: string;

  /**
   *
   */

  dtMemus: {
    startDateVisible: boolean,
    endDateVisible: boolean,
  }
  dtHours: string[];
  constructor() {
    super();

    this.dtMemus = {
      startDateVisible: false,
      endDateVisible: false,
    }

    this.dtHours = [];
    let hour: string | null = null;
    let minute: string | null = null;
    let limitation: number = this.is24h ? this.businessHours.end : 12;
    for (let h = this.businessHours.beginningAt; h < limitation; h++) {
      hour = this._parseNumber(h);
      for (let m = 0; m < 60; m = m + this.step) {
        minute = this._parseNumber(m);
        this.dtHours.push(`${hour}:${minute}`);
      }
    }
  }
  get isInValidRange(): boolean {
    const start: Date = new Date(this.value.startDate.toString());
    const end: Date = new Date(this.value.endDate.toString());
    return start > end;
  }
  private _parseNumber(num: number): string {
    if (num < 10)
      return `0${num}`;
    else return `${num}`
  }
  get vModelStartDateTime(): string | Date | Moment {
    return this.value.startDate
  }
  set vModelStartDateTime(value: string | Date | Moment) {

    const emitValue = this.value;
    emitValue.startDate = `${value}T${this.startTime}:00`;
    emitValue.endDate = (this.vModelEndDateTime as any).substring(0, 16);

    this.$emit('input', emitValue)
  }
  get vModelEndDateTime(): string | Date | Moment {
    return this.value.endDate
  }
  set vModelEndDateTime(value: string | Date | Moment) {

    const emitValue = this.value;
    emitValue.endDate = `${value}T${this.endTime}:00`;
    emitValue.startDate = (this.vModelStartDateTime as any).substring(0, 16);
    this.$emit('input', emitValue)
  }
  get coLocale(): string {
    return this.$i18n.locale;
  }
  get startDate(): string {
    return DateTimeHelper.parseDate(this.vModelStartDateTime);
  }

  get startTime(): string {
    return DateTimeHelper.parseTime(this.value.startDate);
  }
  set startTime(value: string) {

    if (isNullOrUndefined(value) || value.length < 5) {
      value = '00:00'
    }

    const val = { startDate: `${this.vModelStartDateTime.toString().substring(0, 10)}T${value}:00` };

    const _startDate = `${this.vModelStartDateTime.toString().substring(0, 10)}T${value}:00`;
    const _endDate = this.value.endDate.toString().substring(0, _startDate.length);

    this.$emit('input', { startDate: _startDate, endDate: _endDate })
  }
  get endDate(): string {
    return DateTimeHelper.parseDate(this.vModelEndDateTime);
  }

  get endTime(): string {
    return DateTimeHelper.parseTime(this.value.endDate);
  }
  set endTime(value: string) {

    if (isNullOrUndefined(value) || value.length < 5) {
      value = '00:00'
    }
    const _endDate = `${this.vModelEndDateTime.toString().substring(0, 10)}T${value}:00`;
    const _startDate = this.value.startDate.toString().substring(0, _endDate.length);

    this.$emit('input', { startDate: _startDate, endDate: _endDate })
  }

}

export default DatetimePickerRange;


// WEBPACK FOOTER //
// ./src/components/datetime-picker-range/index.ts